import type { Reservation } from '@/api/reservations';

/**
 * DNKADM-0475 (DNKAPI-0690, the 0678 follow-up): a `no_show` booking with its no-show fee
 * still queued (a `pending` deferred charge). Checking it in with `charge:false` cancels that
 * fee, which is a waive: STAFF needs the manager PIN for it, by the same rules as the
 * no-show dialog's waive (DNKADM-0469). The server decides on every call; this only lets the
 * console ask up front.
 */
export function isNoShowFeeQueued(reservation: Reservation): boolean {
  return (
    reservation.status === 'no_show' &&
    (reservation.pendingCharge?.status ?? '').toLowerCase() === 'pending'
  );
}

/** Shown where STAFF cannot waive a queued no-show fee: no manager PIN at this location. */
export const NO_SHOW_FEE_WAIVE_NEEDS_MANAGER =
  'Checking in without a charge cancels the no-show fee. No manager PIN is set at this location, so a manager must do it.';
